const NAMESPACE = "reorderTableDialog";

const KEYS = {
    reorderTableSelectorLabel: "reorderTableSelectorLabel"
};

const MESSAGES = {
    [KEYS.reorderTableSelectorLabel]: {
        value: "New Row Number",
        comment: "Label for row index input selector "
    }
};

export { KEYS, NAMESPACE, MESSAGES };
